import React from 'react';
import {connect} from 'react-redux';
import {Row, Col, Button} from 'react-bootstrap';
import {translate} from '../../i18n/translate.js';
import {formatPrice, formatCredits, formatMoney, formatPoints, orderValidator} from '../../common/basket.js';
import {applyCoupon, setCouponAndUpdateSummary} from "../../actions/store/storeActions";
import {FetchingTypes, PaymentMethod, CouponStatus} from "../../common/constants";
import {isEmptyString} from '../../common/utils';

class StoreOrderSummaryTotal extends React.Component {
    state = {
        disabledApply: true,
        couponLinkClicked: false
    };

    validateCoupon = (props) => {
        if(props.couponStatus === CouponStatus.INVALID) {
            return translate(CouponStatus.INVALID_COUPON);
        } if(props.coupon) {
            let message;

            if(props.coupon.couponType !== "WebStore" ){
                message = translate(CouponStatus.INVALID_COUPON);
            } else if(props.coupon.validationType === CouponStatus.INVALID_COUPON_FIRST_USE) {
                message = translate(CouponStatus.INVALID_COUPON_FIRST_USE);
            } else if(props.coupon.validationType === CouponStatus.INVALID_COUPON_ALREADY_USE) {
                message = translate(CouponStatus.INVALID_COUPON_ALREADY_USE);
            } else {
                message = orderValidator.validateCouponMinimum(props.itemsList, props.extraCost,
                    props.extraCostType, props.creditsData.credits, props.staticData, props.activeOrder, props.coupon);
            }
            if(message) {
                this.props.removeCoupon();
            }
            return message;
        }
    };

    componentWillReceiveProps(nextProps) {
        if(nextProps.couponStatus !== this.props.couponStatus && this.props.couponStatus  === CouponStatus.VALIDATING) {
            const status = this.validateCoupon(nextProps);
            this.setState({invalidStatus: status});
        }
        if(this.props.isDropDownClosed !== nextProps.isDropDownClosed && !nextProps.isDropDownClosed) {
            this.setState({couponLinkClicked: false, invalidStatus:undefined});
        }
    }

    onApplyCouponClicked = () => {
        if (!this.state.disabledApply) {
            this.props.applyCoupon(this.refs.couponId.value);
        }
    };

    onChangeCouponId = (event) => {
        const couponId = event.target.value;
        let invalidStatus = this.state.invalidStatus;
        if(invalidStatus && isEmptyString(couponId)) {
            invalidStatus = undefined;
        }
        this.setState({disabledApply: isEmptyString(couponId), invalidStatus});
    };

    isDisabledCouponButton = () => {
        const enabledPaymentMethods = [PaymentMethod.PAYPAL_STANDARD, PaymentMethod.ELECTRONIC_CHECK, PaymentMethod.CHECK, PaymentMethod.AUTHORIZE_DOT_NET, PaymentMethod.EBT_ONLINE.key];
        const storePaymentMethods = this.props.storePaymentMethods;
        if(this.props.coupon && this.props.coupon.existingCoupon) {
            return enabledPaymentMethods.some(function (method) {
                return storePaymentMethods.includes(method.key);
            });
        }
        return false;
    };

    getCoupon = (couponValue) => {
        if(this.props.hasCoupons) {
            if((this.props.coupon||{}).id && !couponValue) {
                return;
            }
            if(!((this.props.coupon||{}).valid) && !this.state.couponLinkClicked && !this.props.readonly) {
              return(<Row className="store-coupon">
                  <Col xs={12} className="total-title coupon-title" onClick={() =>{this.setState({couponLinkClicked:true});}}>{"+ "+ translate("Add Coupon")}</Col>
              </Row>);
            } else if (this.props.coupon && this.props.couponStatus === CouponStatus.VALID && !this.state.invalidStatus) {
                return (<Row  className="store-coupon">
                    <Col xs={6} className="total-title">{this.props.coupon.id}</Col>
                    <Col xs={6} className="coupon-remove-col">
                        {
                            this.props.readonly ?undefined:
                                <div className="coupon-remove"
                                     name="btnRemoveStoreCoupon"
                                     disabled={this.props.isFetching}
                                     onClick={this.props.removeCoupon}/>
                        }
                        <div className="order-summary-sub-total order-summary-coupon"
                             name="orderSummaryCoupon">{"-" + formatMoney(this.props.coupon.discount)}</div>
                    </Col>
                </Row>);
            } else if(!this.props.readonly){
                const submitLoadingClass = this.props.couponStatus === CouponStatus.VALIDATING ? " loading" : "";
                const submitClasses = "submit-order coupon-btn button" + submitLoadingClass;
                const inputClass = this.state.invalidStatus ? "coupon-code-input coupon-code-input-error" : "coupon-code-input";
                return (<Row className="store-coupon">
                    <Col xs={6} className="total-title input-coupon-col">
                        <input type="text" ref="couponId" id="inpCouponCode" onChange={this.onChangeCouponId}
                               className={inputClass}/>
                    </Col>
                    <Col xs={6} className="total-title coupon-btn-col">
                        <Button disabled={this.state.disabledApply} bsStyle="primary" className={submitClasses}
                                id="btnApplyCoupon"
                                onClick={this.onApplyCouponClicked}>{translate("Apply")}</Button>
                    </Col>
                    {
                        this.state.invalidStatus ?
                            <div className="coupon-code-validation">{this.state.invalidStatus}</div>
                            : undefined
                    }
                </Row>);
            }
        }
    };

    render() {
        let orderTotal = this.props.orderTotal;
        if(this.props.isCredit && !this.props.isCreditItemAsRegularItem) {
            let usedCredits = orderTotal.creditsTotal;
            if (isNaN(usedCredits))
                usedCredits = 0;
            const totalCredits = !this.props.isCreditItemAsRegularItem?formatCredits(usedCredits):("-"+formatMoney(usedCredits));
            return(
                <Row>
                    <Col xs={7} className="total-title">{translate("Total") + " " + this.props.creditItemLabel}:</Col>
                    <Col xs={5} className="order-summary-credits-col">
                        <div className="order-summary-credits" name="orderSummaryTotalCredits">{totalCredits}</div>
                    </Col>
                </Row>
            )
        } else {
            let orderTotalFormatted = formatPrice(orderTotal);
            return (
                <div>
                    {orderTotal.priceBeforeTax ?
                        <Row>
                            <Col xs={6} className="total-title">{translate("Subtotal")}: </Col>
                            <Col xs={6}>
                                <div className="order-summary-sub-total"
                                     name="orderSummarySubTotal">{orderTotalFormatted.priceBeforeTax}</div>
                            </Col>
                        </Row>
                        : undefined
                    }
                    {orderTotal.creditsTotal && this.props.isCreditItemAsRegularItem?
                        <Row>
                            <Col xs={6} className="total-title">{this.props.creditItemLabel}:</Col>
                            <Col xs={6} className="order-summary-credits-col">
                                <div className="order-summary-credits" name="orderSummaryTotalCredits">
                                    {"-" + formatMoney(orderTotal.creditsTotal)}</div>
                            </Col>
                        </Row> : undefined
                    }
                    {orderTotal.tax ?
                        <Row>
                            <Col xs={6} className="total-title">{translate("Tax")}: </Col>
                            <Col xs={6}><div className="order-summary-tax"
                                             name="orderSummaryTax">{orderTotalFormatted.tax}</div>
                            </Col>
                        </Row>
                        : undefined
                    }
                    {orderTotal.extraCostAmount ?
                        <Row>
                            <Col xs={8} className="total-title">{orderTotal.extraCostLabel}</Col>
                            <Col xs={4}><div className="order-summary-sub-total order-summary-extra-cost"
                                             name="orderSummaryExtraCost">{orderTotalFormatted.extraCostAmount}</div>
                            </Col>
                        </Row>
                        : undefined
                    }
                    {orderTotal.usedCredits?
                        <Row>
                            <Col xs={6} className="total-title">{translate("Credits")}:</Col>
                            <Col xs={6}><div className="order-summary-sub-total order-summary-used-credits"
                                             name="orderSummaryUsedCredits">{orderTotalFormatted.usedCredits}</div>
                            </Col>
                        </Row>
                        : undefined
                    }
                    {orderTotal.balanceAsCredits ?
                        <Row>
                            <Col xs={6} className="total-title">{translate("Credit Applied")}:</Col>
                            <Col xs={6}><div className="order-summary-sub-total order-summary-used-credits"
                                             name="orderSummaryUsedCredits">{orderTotalFormatted.balanceAsCredits}</div>
                            </Col>
                        </Row>
                        : undefined
                    }
                    {this.getCoupon(this.props.orderTotal.couponValue)}
                    <hr className="summary-item-divider"/>
                    <Row>
                        <Col xs={6} className="total-title">{translate("Total")}: </Col>
                        <Col xs={6}><div className="order-summary-grand-total"
                                          name="orderSummaryGrandTotal">{orderTotalFormatted.fullPrice}</div></Col>
                    </Row>
                    {this.props.staticData.showItemPoints &&
                        <Row>
                            <Col xs={6} className="total-title">{translate("Total Points")}: </Col>
                            <Col xs={6}><div className="order-summary-grand-total"
                                             name="orderSummaryPointsTotal">{formatPoints(this.props.totalPoints)}</div></Col>
                        </Row>
                    }
                </div>
            )
        }
	}
}

const mapStateToProps = (state) => {
    const orderStatus = (state.orderStatus||{});
    const staticData = (state.staticData || {});
    const summary = (state.summary||{});
    const couponStatus = (state.fetching.isFetching && state.fetching.fetchingType === FetchingTypes.VALIDATE_COUPON) ? CouponStatus.VALIDATING :
        !orderStatus.coupon? CouponStatus.NONE:orderStatus.coupon.valid ? CouponStatus.VALID : CouponStatus.INVALID;
    return {
        staticData: state.staticData,
        hasCoupons: orderStatus.hasCoupons,
        coupon: orderStatus.coupon,
        couponStatus: couponStatus,
        storePaymentMethods: staticData.storePaymentMethods,
        creditsData: (state.storeCreditsData || {}),
        extraCost: (state.summary||{}).extraCost,
        itemsList: state.itemsList,
        extraCostType: summary.extraCostType,
        activeOrder: orderStatus.activeOrder,
        isDropDownClosed: (state.checkout||{}).isDropDownClosed,
        isCreditItemAsRegularItem: state.staticData.isCreditItemAsRegularItem,
        creditItemLabel: state.staticData.creditItemLabel
    };
};
const mapDispatchToProps = dispatch => {
    return {
        applyCoupon: (couponId) => {
            dispatch(applyCoupon(couponId));
        },
        removeCoupon: () => {
            dispatch(setCouponAndUpdateSummary(undefined));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreOrderSummaryTotal);



// WEBPACK FOOTER //
// ./src/components/store/StoreOrderSummaryTotal.js